var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0873 18.6875C41.5998 17.875 40.6248 17.55 39.8123 18.0375C38.1873 18.85 36.7248 19.9875 35.4248 21.125C34.4498 14.1375 32.0123 1.625 25.9998 1.625C19.9873 1.625 17.5498 14.1375 16.5748 21.125C15.2748 19.9875 13.6498 19.0125 12.1873 18.0375C11.3748 17.7125 10.3998 17.875 9.9123 18.6875C9.5873 19.5 9.7498 20.475 10.5623 20.9625C12.0248 21.775 13.3248 22.75 14.6248 23.725V39C14.6248 45.3375 19.6623 50.375 25.9998 50.375C32.3373 50.375 37.3748 45.3375 37.3748 39V23.725C38.6748 22.75 39.9748 21.775 41.4373 20.9625C42.2498 20.475 42.4123 19.5 42.0873 18.6875ZM25.9998 4.875C27.7873 4.875 31.1998 10.8875 32.4998 23.8875C29.5748 26.975 27.4623 30.7125 25.9998 34.6125C24.6998 30.55 22.4248 26.975 19.4998 23.8875C20.7998 10.8875 24.2123 4.875 25.9998 4.875Z",
    fill: "#8BC34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFields);
export default __webpack_public_path__ + "static/media/fields.0fc630a67407832d42ac0a4bf6feaf3e.svg";
export { ForwardRef as ReactComponent };